import type { UserInterface } from "@/stores/user";
import api, {type ApiResponse, doError} from "@/axios.js";
import {defineStore} from 'pinia'
import type {ServiceOptionsInterface, ServicesInterface} from "@/stores/services.ts";
import type {PersonsInterface} from "@/stores/persons.ts";

export interface orderInterface {
    id: number,
    user_id: number,
    user?: UserInterface,
    created_at: string,
    date: string,
    start: string,
    end:string;
    service_id: number,
    service?: ServicesInterface,
    service_option_id: number|null,
    service_option?: ServiceOptionsInterface,
    person_id: number|null,
    person?: PersonsInterface,
    status: number
    start_time_human?: string,
    date_human?: string
    valid?: boolean,
    price:number
}

export interface filterInterface{
    search: string,
    date: [string, string],
    person_id: number|null
}


let allRequest=0;
export const useOrdersStore = defineStore('order', {
    state: () => ({
        _orders: null as orderInterface[] | null,
        _my: null as orderInterface[] | null,
        _all: null as orderInterface[] | null,
    }),
    getters: {
        list: (state) => state._orders,
        my: (state) => state._my,
        all: (state) => state._all
    },
    actions: {
        async loadForCustomer(userId: number, signal?: AbortSignal): Promise<orderInterface[]> {
            const response = await api.get<ApiResponse<orderInterface[]>>('/orders/all', {
                params: { user_id: userId }, signal,
            });
            return response.data.data;
        },
        async load(): Promise<void> {
            try {
                const response = await api.get<ApiResponse< orderInterface[] >>('/orders');
                this._orders = response.data.data;
            } catch (err: any) {
                doError(err);
            }
        },
        async loadMy(): Promise<void> {
            try {
                const response = await api.get<ApiResponse< orderInterface[] >>('/orders/my');
                this._my = response.data.data;
            } catch (err: any) {
                doError(err);
            }
        },
        async loadAll(filter:filterInterface): Promise<void> {
            const request=++allRequest;
            try {
                const response = await api.get<ApiResponse< orderInterface[] >>('/orders/all', {params: filter});
                if (request===allRequest) this._all = response.data.data;
            } catch (err: any) {
                doError(err);
            }
        },
        async createReservation(order: orderInterface, key: string) {
            try {
                const response = await api.post('/orders', { date: order.date, start: order.start, service_option_id: order.service_option_id, person_id: order.person_id, idempotency_key: key });
                this._orders = [...(this._orders || []).filter(item => item.id !== response.data.data.id), response.data.data];
            }  catch (err: any) {
                doError(err);
            }
        },
        async updateStatus(order:orderInterface) {
            try {
                await api.put(`/orders/update-single`, { id: order.id, status: 15 });
                this._orders=this._orders?.filter(item=>item.id!==order.id)??null;
                this._my=this._my?.filter(item=>item.id!==order.id)??null;
                this._all=this._all?.filter(item=>item.id!==order.id)??null;
            }  catch (err: any) {
                doError(err);
            }
        },
        async cancelOrders(selected: number[], reason: string): Promise<void> {
            try {
                await api.post('/orders/cancel', {selected, reason});
                this._orders = this._orders?.filter(item => !selected.includes(item.id)) ?? null;
                this._my = this._my?.filter(item => !selected.includes(item.id)) ?? null;
                this._all = this._all?.filter(item => !selected.includes(item.id)) ?? null;
            } catch (err: any) {
                doError(err);
            }
        }
    }
})
